import { defineMessages } from 'react-intl';

export const createMenuMessages = defineMessages({
  promptSelectClinicians: {
    defaultMessage: 'First select clinicians to create a session',
    id: 'oZx/tD278L',
    description:
      'Accessible label on the create-session action while no clinician is selected',
  },
  triggerLabel: {
    defaultMessage: 'Create',
    id: 'z7vRraArtt',
    description: 'Sidebar button that opens the universal create menu',
  },
  header: {
    defaultMessage: 'New',
    id: 'MssgOa+TmS',
    description: 'Heading of the universal create menu',
  },
  session: {
    defaultMessage: 'Session',
    id: 'C/nkpqooT/',
    description: 'Universal create-menu item that starts a new session',
  },
  chat: {
    defaultMessage: 'Chat',
    id: 'tT/h4TZFG/',
    description: 'Universal create-menu item that starts a new chat',
  },
  task: {
    defaultMessage: 'Task',
    id: 'hy19zS3Tde',
    description: 'Universal create-menu item that creates a task',
  },
  template: {
    defaultMessage: 'Template',
    id: 'xzA8sWQdvM',
    description: 'Universal create-menu item that creates a template',
  },
  pdfForm: {
    defaultMessage: 'PDF form',
    id: 'HG34onC5vD',
    description: 'Universal create-menu item that starts a PDF form upload',
  },
  xmlForm: {
    defaultMessage: 'Form',
    id: 'h5xknHN4ek',
    description:
      'Universal create-menu item that starts form-template upload on a build where only XML forms are supported',
  },
});
